/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
// import styles from './Footer.module.scss';
import React from "react";
import styles from "./InputSelectV2.module.scss";
import mainS from "../../../assets/scss/global.module.scss";
import Select, { StylesConfig, components, ControlProps } from "react-select";
import classNames from "classnames";
import { levelLabels } from "@podcasts/constants"

interface SelectProps {
  label?: string;
  placeholder?: string;
  value?: any;
  onChange?: any;
  onBlur?: any;
  error?: string | null;
  name?: string;
  options: any[];
  disabled?: boolean;
}

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="10"
        viewBox="0 0 16 10"
        fill="none"
      >
        <path
          d="M9.08008 8.92792C8.49014 9.54011 7.50984 9.54011 6.91989 8.92792L1.61737 3.42553C0.699315 2.47287 1.37444 0.884669 2.69747 0.884669L13.3025 0.88467C14.6255 0.88467 15.3007 2.47287 14.3826 3.42553L9.08008 8.92792Z"
          stroke="black"
        />
      </svg>
    </components.DropdownIndicator>
  );
};

const dot = (color = "transparent") => ({
  alignItems: "center",
  display: "flex",
});

const Control = ({ children, ...props }: ControlProps<any, false>) => {
  // @ts-ignore
  const { onEmojiClick } = props.selectProps;

  return (
    <components.Control {...props}>
      <div className={styles["select-box"]}>
        <span onMouseDown={onEmojiClick} className={styles["select-prev-text"]}>
          Viewing as:
        </span>
        <span className={styles["select-input"]}>{children}</span>
      </div>
    </components.Control>
  );
};

const colourStyles = (error: any): StylesConfig<any> => ({
  //@ts-ignore
  control: (styles) => ({
    ...styles,
    border: 0,
    background: "transparent",
    borderColor: error ? "red" : "#000000",
    boxShadow: "none",
  }),
  //@ts-ignore
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      fontSize: "15px",
      backgroundColor: isDisabled
        ? undefined
        : isSelected
          ? undefined
          : isFocused
            ? "#fee8b6"
            : undefined,
      color: isDisabled
        ? undefined
        : isSelected
          ? "#000"
          : isFocused
            ? "#000"
            : undefined,
      cursor: isSelected ? "not-allowed" : "default",
      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled
          ? isSelected
            ? undefined
            : "#fee8b6"
          : undefined,
      },
    };
  },
  //@ts-ignore
  input: (styles) => ({ ...styles, ...dot() }),
  //@ts-ignore
  placeholder: (styles) => ({ ...styles, ...dot("#ccc") }),
  //@ts-ignore
  singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) }),
  //@ts-ignore
  indicatorSeparator: (styles) => ({
    ...styles,
    background: "transparent",
    paddingLeft: 0,
    margin: 0,
  }),
  //@ts-ignore
  valueContainer: (styles) => ({ ...styles, padding: "2px 0" }),
  //@ts-ignore
  dropdownIndicator: (styles) => ({ ...styles, padding: "2px 11px 0 0" }),
  //@ts-ignore
  menu: (styles) => ({
    ...styles,
    marginTop: "-5px",
    backgroundColor: "#FFF8E8",
    border: 0,
    borderTop: "1px solid #EDEDED",
    borderRadius: "0 0 5px 5px",
    boxShadow: "none",
  }),
});

export function InputSelectV2({
  name = "",
  label = "",
  placeholder = levelLabels.BEGINNER,
  value = "",
  onChange,
  onBlur,
  error,
  options = [],
  disabled = false,
}: SelectProps) {
  const classNamesForInput = classNames(
    styles["inputContainer"],
    error ? mainS["inputError"] : ""
  );
  return (
    <div>
      <div className={classNamesForInput}>
        <label style={{ marginBottom: `${!label ? 0 : "0.5rem"}` }}>
          {label}
        </label>
        <Select
          isDisabled={disabled}
          name={name}
          options={options}
          placeholder={value || placeholder}
          styles={colourStyles(error)}
          components={{ DropdownIndicator, Control }}
          defaultValue={options.find((d) => d.value === value) || null}
          onChange={(e: any) => onChange(e)}
          onBlur={onBlur}
        />
        {error && <span className={mainS["errorMessage"]}>{error}</span>}
      </div>
    </div>
  );
}

export default InputSelectV2;
